import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import styles from "./Palpaciones.module.css";
import History from "../../components/history";
import { Icon } from '@iconify/react';
import { Button, Form, Table, Row, Col } from "react-bootstrap";
import { useCookies } from 'react-cookie';
import { checkSession, isMobile } from "../../core/session";
import editFilled from '@iconify/icons-ant-design/edit-filled';
import bxsTrash from '@iconify/icons-bx/bxs-trash';
import plusCircleOutlined from '@iconify/icons-ant-design/plus-circle-outlined';
import axios from "axios";
import Notifications, {notify} from "react-notify-toast";

const Palpaciones = (props) => {

    const loadingBtn = require("../../assets/loaders/btn-loading.gif");

    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);
    const [showModal, setShowModal] = useState(false);

    const [palpacion, setPalpacion] = useState({ detalles: [] });
    const [temporada, setTemporada] = useState("PRIMAVERA");

    const [loading, setLoading] = useState(false);
    const [loadingXls, setLoadingXls] = useState(false);

    const TEMP_MESES = { "PRIMAVERA": ["AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"], "OTOÑO": ["APRIL", "MAY"]}

    const [ palpacionLinea, setPalpacionLinea ] = useState({ meses: { AUGUST: undefined, SEPTEMBER: undefined, OCTOBER: undefined, NOVEMBER: undefined, DECEMBER: undefined } });

    const [year, setYear] = useState(new Date().getFullYear());

    const history = [
        {
            name: "Inicio",
            path: "/"
        }
    ]

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    }

    const guardar = (e) => {
        e.preventDefault();
        const { id:idEstancia } = cookie.kUserSession.data["farm"];
        const data = { ...palpacion, idEstancia, periodo: year, temporada };
        axios.post(process.env.REACT_APP_API_URL + "palpaciones", data, prepareHeaders()).
        then(rs => {
            notify.show("Palpación guardada correctamente", "success");
            getPalpaciones();
        }).
        catch(err => {
            console.log(err);
            getPalpaciones();
            notify.show("Error al guardar la palpación", "error");
        });
    }

    const getPalpaciones = () => {
        setLoading(true);
        const { id:idEstancia } = cookie.kUserSession.data["farm"];
        axios.get(process.env.REACT_APP_API_URL + `palpaciones?id_estancia=${idEstancia}&periodo=${year}&temporada=${temporada}`, prepareHeaders()).
        then(rs => {
            if(rs.status == 200){
                setPalpacion(rs.status ? rs.data : { detalles: [] })
            }
            else {
                setPalpacion({ detalles: [] });
            }
            setLoading(false);
        }).
        catch(err => {
           console.log(err);
           setPalpacion({ detalles: [] });
           setLoading(false);
        });
    };

    const generarExcel = (e) => {
        e.preventDefault();
        setLoadingXls(true);
        const { id: idEstancia } = cookie.kUserSession.data["farm"];
        let url = process.env.REACT_APP_API_URL + `palpaciones/report?periodo=${year}&id_estancia=${idEstancia}&temporada=${temporada}`;
        fetch(url, prepareHeaders())
        .then(response => {
            const filename = response.headers.get("content-disposition").split("filename=")[1];
            response.blob().then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                setLoadingXls(false);
                notify.show("Reporte generado exitosamente", "success");
            });
        }).catch(error => {
            console.error(error);
            notify.show("Ha ocurrido un error al generar el reporte", "error");
            setLoadingXls(false);
        });
    }

    useEffect(() => {
        checkSession("expenses", props.history, cookie.kUserSession);
        getPalpaciones();
    }, []);

    useEffect(() => {
        getPalpaciones();
    }, 
    [year, temporada]);

    const addLote = (e) => {
        e.preventDefault();
        let detalles = palpacion.detalles || [];
        if(palpacionLinea.palpacionLote){
            detalles.push(palpacionLinea);
            setPalpacion({ ...palpacion, detalles });
            setPalpacionLinea({ palpacionLote: "", vacasSecas: "", meses: temporada == "PRIMAVERA" ? { AUGUST: "", SEPTEMBER: "", OCTOBER: "", NOVEMBER: "", DECEMBER: "" } : { APRIL: "", MAY: "" } });
        }
        else {
            notify.show("Por favor complete todos los campos del lote", "error");
        }
    }

    const toggleEdit = (e, index) => {
        e.preventDefault();
        const nuevosDetalles = palpacion.detalles.map((d, i) => i === index ? { ...d, disabled: d.disabled == undefined ? false : !d.disabled } : d);
        console.log(nuevosDetalles, index);
        setPalpacion({ ...palpacion, detalles: nuevosDetalles });
    }

    const changeLote = (e, index) => {
        e.preventDefault();
        const nuevosDetalles = palpacion.detalles.map((d, i) => i === index ? { ...d, palpacionLote: e.target.value } : d);
        setPalpacion({ ...palpacion, detalles: nuevosDetalles });
    }

    const changeSecas = (e, index) => {
        e.preventDefault();
        const nuevosDetalles = palpacion.detalles.map((d, i) => i === index ? { ...d, vacasSecas: e.target.value } : d);
        setPalpacion({ ...palpacion, detalles: nuevosDetalles });
    }

    const changeLoteMes = (e, index, mes) => {
        e.preventDefault();
        const nuevosDetalles = palpacion.detalles.map((d, i) => {
            if (i === index) {
                const meses = { ...d.meses, [mes]: e.target.value };
                return { ...d, meses };
            }
            return d;
        });
        setPalpacion({ ...palpacion, detalles: nuevosDetalles });
    }

    const removeLote = (e, index) => {
        e.preventDefault();
        const nuevosDetalles = palpacion.detalles.filter((_, i) => i !== index);
        setPalpacion({ ...palpacion, detalles: nuevosDetalles });
    }

    return (
        <>
            <Notifications />
            <Header history={props.history} />
            <section className={styles.body}>
                <Row>
                    <Col>
                        <History items={history} current={"Palpaciones"} history={props.history} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <section className={styles.content}>
                            <Row>
                                <Col>
                                    <h1 className={styles.title}>Palpaciones, {year-1 + '/' + year}</h1>
                                </Col>
                                <Col md={12} style={{ marginTop: "1rem", display: "flex", gap: "2rem" }}>
                                    <Form.Group style={{marginBottom: "15px"}}>
                                        <Form.Label htmlFor="primavera" className={styles.label}>Temporada</Form.Label>
                                        <Form.Control id="primavera" className={"karanda-input"} value={temporada} onChange={(e) => {setTemporada(e.target.value); }} as="select" style={{ marginRight: "1rem" }}>
                                            <option>OTOÑO</option>
                                            <option>PRIMAVERA</option>
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group style={{marginBottom: "15px"}}>
                                        <Form.Label htmlFor="periodo" className={styles.label}>Periodo</Form.Label>
                                        <div style={{ display: "flex" }}>
                                            <Form.Control id="periodo" className={"karanda-input"} value={year} onChange={(e) => {setYear(e.target.value); }} type="number" style={{ marginRight: "1rem" }}/>
                                            <Button className="karanda-btn" disabled={loadingXls} onClick={generarExcel}>
                                                Descargar
                                                {
                                                    loadingXls ? (
                                                        <>
                                                            &nbsp;&nbsp;<img src={loadingBtn} height="15" />
                                                        </>
                                                    ) : <></>
                                                }
                                            </Button>                                           
                                        </div>
                                    </Form.Group>                                
                                </Col>                                                             
                            </Row>

                            <section className={styles.actions}>
                                <Row>
                                    <Col>
                                        <Form.Label className="karanda-label">Fecha de palpacion</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={palpacion.fechaPalpacion || ""}
                                            onChange={(e) => setPalpacion({ ...palpacion, fechaPalpacion: e.target.value })}
                                        />
                                    </Col>
                                    <Col>
                                        <Form.Label className="karanda-label">Carimbo</Form.Label>
                                        <Form.Control
                                            placeholder="Ingrese el carimbo"
                                            type="number"
                                            value={palpacion.carimbo || ""}
                                            onChange={(e) => setPalpacion({ ...palpacion, carimbo: e.target.value })}
                                        />
                                    </Col>
                                    <Col>
                                        <Form.Label className="karanda-label">Vacas servidas</Form.Label>
                                        <Form.Control
                                            placeholder="Ingrese las vacas servidas"
                                            type="number"
                                            value={palpacion.vacasServidas || ""}
                                            onChange={(e) => setPalpacion({ ...palpacion, vacasServidas: e.target.value })}
                                        />
                                    </Col>
                                </Row>
                                <Table style={{ marginTop: "1rem" }} className="karanda-table">
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "center" }}>LOTE</th>
                                            {
                                                TEMP_MESES[temporada].map((mes, index) => (
                                                    <th style={{ textAlign: "center" }} key={index}>{mes}</th>
                                                ))
                                            }
                                            <th style={{ textAlign: "center" }}>PREÑADAS</th>
                                            <th style={{ textAlign: "center" }}>SECAS</th>
                                            <th style={{ textAlign: "center" }}>PREÑEZ %</th>
                                            <th></th>                                    
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            palpacion && palpacion.detalles && palpacion.detalles.map((lote, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <Form.Control className="karanda-input karanda-input-small" style={{ width: "30rem" }} type="text" value={lote.palpacionLote} disabled={lote.disabled || lote.disabled == undefined} onChange={(e) => { changeLote(e, index); }}/>
                                                    </td>
                                                    {
                                                        TEMP_MESES[temporada].map((mes, mesIndex) => (
                                                            <td key={mesIndex}>
                                                                <Form.Control className="karanda-input karanda-input-small"  type="number" value={lote.meses[mes]} disabled={lote.disabled || lote.disabled == undefined} onChange={(e) => { changeLoteMes(e, index, mes); }}/>
                                                            </td>
                                                        ))
                                                    }
                                                    <td>
                                                        <Form.Control 
                                                            className="karanda-input karanda-input-small" 
                                                            type="number" 
                                                            disabled
                                                            value={ Object.values(lote.meses || {}).reduce((acc, val) => acc + (parseFloat(val) || 0), 0)} 
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control className="karanda-input karanda-input-small"  type="number" value={lote.vacasSecas} disabled={lote.disabled || lote.disabled == undefined} onChange={(e) => { changeSecas(e, index); }}/>
                                                    </td>
                                                    <td>
                                                        <Form.Control 
                                                            className="karanda-input karanda-input-small" 
                                                            type="number"
                                                            disabled 
                                                            value={ lote.vacasSecas ? ( (Object.values(lote.meses || {}).reduce((acc, val) => acc + (parseFloat(val) || 0), 0)) / (parseFloat(lote.vacasSecas) + Object.values(lote.meses || {}).reduce((acc, val) => acc + (parseFloat(val) || 0), 0))*100).toFixed(2) : undefined }
                                                        />
                                                    </td>
                                                    <td>
                                                        <Icon className={styles.icon} icon={editFilled} height="15px" onClick={(e) => { toggleEdit(e, index); }} />&nbsp;
                                                        <Icon className={styles.icon} icon={bxsTrash} height="15px" onClick={(e) => { removeLote(e, index); }} />
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                        <tr>
                                            <td>
                                                <Form.Control 
                                                    className="karanda-input karanda-input-small" 
                                                    type="text" 
                                                    placeholder="Ingrese el lote" 
                                                    style={{ width: "30rem" }} 
                                                    value={palpacionLinea.palpacionLote} 
                                                    onChange={(e) => setPalpacionLinea({ ...palpacionLinea, palpacionLote: e.target.value })}
                                                />
                                            </td>
                                            {
                                                TEMP_MESES[temporada].map((mes, index) => (
                                                    <td>
                                                        <Form.Control 
                                                            className="karanda-input karanda-input-small" 
                                                            type="number" 
                                                            value={palpacionLinea.meses[mes]} 
                                                            onChange={(e) => setPalpacionLinea({ ...palpacionLinea, meses: { ...palpacionLinea.meses, [mes]: e.target.value }})} 
                                                        />
                                                    </td>
                                                ))
                                            }                                            
                                            <td>
                                                <Form.Control className="karanda-input karanda-input-small"  type="number" disabled value={ Object.values(palpacionLinea.meses || {}).reduce((acc, val) => acc + (parseFloat(val) || 0), 0)} />
                                            </td>
                                            <td>
                                                <Form.Control 
                                                    className="karanda-input karanda-input-small" 
                                                    type="number" 
                                                    value={palpacionLinea.vacasSecas} 
                                                    onChange={(e) => setPalpacionLinea({ ...palpacionLinea, vacasSecas: e.target.value })} 
                                                />
                                            </td>
                                            <td>
                                                <Form.Control 
                                                    className="karanda-input karanda-input-small" 
                                                    type="number" 
                                                    disabled 
                                                    value={ palpacionLinea.vacasSecas ? ( (Object.values(palpacionLinea.meses || {}).reduce((acc, val) => acc + (parseFloat(val) || 0), 0)) / (parseFloat(palpacionLinea.vacasSecas) + Object.values(palpacionLinea.meses || {}).reduce((acc, val) => acc + (parseFloat(val) || 0), 0))*100).toFixed(2) : undefined }
                                                />
                                            </td>
                                            <td>
                                                <Icon className={styles.icon} icon={plusCircleOutlined} height="35px" onClick={addLote}/>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>

                                    </tfoot>
                                </Table>
                                <div style={{ textAlign: "right" }}>
                                    <Button onClick={guardar}>Guardar</Button>
                                </div>
                            </section>

                        </section>                    
                    </Col>
                </Row>
            </section>
        </>
    );

};

export default Palpaciones;